export default __webpack_public_path__ + "static/media/image9.2e36b425.jpg";